"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconBookmark', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M2 2C2 1.44772 2.44772 1 3 1H13C13.5523 1 14 1.44772 14 2V14C14 14.3844 13.7797 14.7348 13.4332 14.9013C13.0867 15.0678 12.6755 15.021 12.3753 14.7809L8 11.2806L3.6247 14.7809C3.32453 15.021 2.91328 15.0678 2.56681 14.9013C2.22035 14.7348 2 14.3844 2 14V2ZM4 3V11.9194L7.37531 9.21913C7.74052 8.92696 8.25948 8.92696 8.62469 9.21913L12 11.9194V3H4Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M3 2C3 1.44772 3.44772 1 4 1H16C16.5523 1 17 1.44772 17 2V18C17 18.388 16.7755 18.741 16.4242 18.9056C16.0728 19.0702 15.6579 19.0166 15.3598 18.7682L10 14.3017L4.64018 18.7682C4.3421 19.0166 3.92723 19.0702 3.57584 18.9056C3.22446 18.741 3 18.388 3 18V2ZM5 3V15.865L9.35982 12.2318C9.73066 11.9227 10.2693 11.9227 10.6402 12.2318L15 15.865V3H5Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M4.99988 2C4.99988 1.44772 5.44759 1 5.99988 1H19.9999C20.5522 1 20.9999 1.44772 20.9999 2V22C20.9999 22.3905 20.7725 22.7453 20.4177 22.9085C20.0629 23.0717 19.6456 23.0134 19.3491 22.7593L12.9999 17.3171L6.65067 22.7593C6.35416 23.0134 5.93682 23.0717 5.58202 22.9085C5.22722 22.7453 4.99988 22.3905 4.99988 22V2ZM6.99988 3V19.8258L12.3491 15.2407C12.7236 14.9198 13.2762 14.9198 13.6507 15.2407L18.9999 19.8258V3H6.99988Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M5.00012 3.5C5.00012 2.67157 5.67169 2 6.50012 2H25.5001C26.3285 2 27.0001 2.67157 27.0001 3.5V28.5C27.0001 29.0659 26.6817 29.5836 26.1766 29.8388C25.6716 30.094 25.0659 30.0433 24.6103 29.7076L16.0001 23.3632L7.38992 29.7076C6.93436 30.0433 6.32867 30.094 5.82362 29.8388C5.31857 29.5836 5.00012 29.0659 5.00012 28.5V3.5ZM8.00012 5V25.5315L15.1103 20.2924C15.6395 19.9025 16.3608 19.9025 16.8899 20.2924L24.0001 25.5315V5H8.00012Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;